export default __webpack_public_path__ + "static/media/Algemene checklist 2020.ede98d35.pdf";